/**
 * Standardized Business Categories
 * This is the single source of truth for business categories across the application
 */

export const BUSINESS_CATEGORIES = [
  "Accountancy & Tax Services",
  "Attractions & Culture",
  "Automotive & Motoring",
  "Beauty & Hair",
  "Bike Shops & Repairs",
  "Building & Construction",
  "Business Support Services",
  "Celebrants & Ceremonies",
  "Cleaning Services",
  "Counselling",
  "Education & Childcare",
  "Electricians",
  "Energy & Utilities",
  "Engineering & Manufacturing",
  "Entertainment & Leisure",
  "Festivals",
  "Financial Services",
  "Fitness & Wellbeing",
  "Florists & Garden Centres",
  "Food & Drink",
  "Funeral Services",
  "Health & Medical",
  "Home & Garden",
  "Home Improvement & Renovation",
  "Hospitality & Accommodation",
  "Hypnotherapy",
  "IT & Technology",
  "Legal Services",
  "Life Coaching",
  "Locksmiths",
  "Logistics & Distribution",
  "Marketing, Design & Creative",
  "Painters & Decorators",
  "Pets & Animals",
  "Photography & Videography",
  "Plumbing & Heating",
  "Property Services",
  "Public Services & Government",
  "Pubs & Bars",
  "Recruitment & HR",
  "Repairs & Servicing",
  "Retail & Shopping",
  "Security Services",
  "Self Storage",
  "Surveyors",
  "Takeaways & Delivery",
  "Taxis & Transport",
  "Travel & Tourism",
  "Wedding Services",
  "Other"
];

// ── SEO-friendly slug helpers ───────────────────────────────────────────
// Source of truth for the URL form of each category. Keeps clean URLs
// like /business/cafes-and-restaurants instead of the old query-string
// /business?category=Cafes%20%26%20Restaurants form.

import { slugify } from '../utils/slugify';

/** "Cafes & Restaurants" → "cafes-and-restaurants" */
export const categoryToSlug = (name) => slugify(name || '');

/** "cafes-and-restaurants" → "Cafes & Restaurants" (or undefined if unknown) */
export const slugToCategory = (slug) => {
  if (!slug) return undefined;
  return BUSINESS_CATEGORIES.find(c => slugify(c) === slug);
};

/** Path-style URL for a category, optionally with extra query params. */
export const categoryPath = (name, extraQuery = {}) => {
  const slug = categoryToSlug(name);
  const qs = new URLSearchParams(extraQuery).toString();
  if (!slug) return `/business${qs ? `?${qs}` : ''}`;
  return `/business/${slug}${qs ? `?${qs}` : ''}`;
};

export default BUSINESS_CATEGORIES;
